import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGetForwardMessageSelectProperties } from "./useGetForwardMessageSelectProperties";
import SelectChatWrapper from "../SelectChatWrapper/SelectChatWrapper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForwardMessageSelect',
  setup(__props) {

const {
  listsContainerHeight,
  lists,
  handleRedirect,
  selectedGroupMembers,
  handleAddGroupMember,
  handleRemoveGroupMember,
  sendForwardedMessage,
  isRecommendationsVisible,
} = useGetForwardMessageSelectProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectChatWrapper, {
    "lists-container-height": _unref(listsContainerHeight),
    lists: _unref(lists),
    "is-recommendations-visible": _unref(isRecommendationsVisible),
    "selected-members": _unref(selectedGroupMembers),
    title: _ctx.$t('settings.chat.forwardMessage.title'),
    "confirm-title": _ctx.$t('settings.chat.forwardMessage.actionTitle'),
    onAddSelected: _unref(handleAddGroupMember),
    onRemoveSelected: _unref(handleRemoveGroupMember),
    onRedirect: _unref(handleRedirect),
    onConfirm: _unref(sendForwardedMessage)
  }, null, 8, ["lists-container-height", "lists", "is-recommendations-visible", "selected-members", "title", "confirm-title", "onAddSelected", "onRemoveSelected", "onRedirect", "onConfirm"]))
}
}

})